import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from './../environments/environment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { AppNavbarComponent } from './app-navbar/app-navbar.component';
import { SearchComponent } from './search/search.component';
import { AboutComponent } from './about/about.component';
import { LandingComponent } from './landing/landing.component';
import { OfferComponent } from './offer/offer.component';
import { LoginComponent } from './users/login/login.component';
import { SignupComponent } from './users/signup/signup.component';
import { CreateComponent } from './create/create.component';
import { CopayRebateComponent } from './create/copay-rebate/copay-rebate.component';

import { AuthService } from './core/auth.service';

import { AuthGuard } from './auth.guard';


const appRoutes: Routes = [
  { path: 'search', component: SearchComponent },
  { path: 'about',  component: AboutComponent },
  { path: 'offer/:id', component: OfferComponent },
  { path: 'create/copay-rebate', component: CopayRebateComponent},
  { path: 'login', component: LoginComponent },
  { path: 'create', component: CreateComponent },
  { path: '', component: LandingComponent },
  { path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];


@NgModule({
  declarations: [
    AppComponent,
    AppNavbarComponent,
    SearchComponent,
    AboutComponent,
    LandingComponent,
    OfferComponent,
    LoginComponent,
    SignupComponent,
    CreateComponent,
    CopayRebateComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- true for debugging purposes only
    )
  ],
  providers: [AngularFirestore, AuthService, AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts